function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable camelcase */
import * as React from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { json } from 'd3-request';
import { nest } from 'd3-collection';
import GoogleTagManager from '@ta-interaktiv/react-gtm';
import browsercheck from '@ta-interaktiv/browsercheck';
var LOADING = 'loading';
var ERROR = 'error';
var READY = 'ready';

/**
 * Component to track visits to a website, accessing the Newsnet API for all
 * tracking information. Currently supports GTM, WEMF and Webseismo.
 * Additional Providers need to be added separately.
 *
 * @example <caption>Use the Newsnet API to get the necessary data</caption>
 * import Tracking from '@ta-interaktiv/react-tracking'
 * function YourComponent (props) {
 *   return (
 *     <div>
 *       <Tracking articleId='3352335' />
 *     </div>
 *   )
 * }
 *
 * @example <caption>Add in data directly, circumventing network
 * requests</caption>
 *
 * // Access Newsnet API somewhere and get data
 * let newsnetData = fetch('m.tenant.ch/api/articles/111111/external_services')
 *
 * render () {
 *   return (
 *     <Tracking articleId={111111}
 *               gtmId={newsnetData.configs.gtm_id}
 *               statisticsConfig={newsnetData.statistics}
 *     />
 *   )
 * }
 *
 *
 *
 * @param {Props} props
 * @param {string} [props.articleId] - Article ID of the link article in
 * the CD. If not available it will assume that content is being loaded in an
 * iframe. So, yes, you can use this component without adding the
 * `articleId` attribute. Make sure that you also pass an article ID when
 * passing in the statistics configuration and GTM ID directly, otherwise
 * WEMF won't track!
 * @param {string} [props.gtmId] - Google Tag Manager ID. If this isn't
 * passed in, the component will fetch the necessary data from the Newsnet API.
 * @param {Array<Statistic>} [props.statisticsConfigs] - Array with
 * statistics configuration objects as provided by Newsnet API. Together
 * with the GTM ID, passing these in will prevent the component from making
 * a network request.
 * @extends React.PureComponent
 */
export var Tracking =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Tracking, _React$PureComponent);

  function Tracking() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tracking);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tracking)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.props = void 0;
    _this.loadTimestamp = Date.now();
    _this.state = {
      loadingState: LOADING,
      gtmArticleData: []
    };
    return _this;
  }

  _createClass(Tracking, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loadingState === LOADING || this.state.loadingState === ERROR) {
        return null;
      }

      if (this.state.loadingState === READY && this.state.gtmId) {
        return React.createElement("div", {
          className: "tracking"
        }, this.state.gtmArticleData.map(function (tracker, index) {
          return React.createElement(GoogleTagManager, {
            gtmId: _this2.state.gtmId,
            gtmTrackingConfig: tracker,
            key: index
          });
        }));
      }
    }
    /**
     * Called after component has been mounted. This should only be called
     * once within the component lifecycle, even with state and props changing.
     * @private
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Data has already been loaded, no need to to complicated fetches
      if (this.props.gtmId && this.props.statisticsConfigs) {
        this.setupTracking(this.props.statisticsConfigs, this.props.gtmId);
        return;
      } // Otherwise go fetch the statistics data from remote


      var hostdomain = parseHostname().publicationDomain;

      if (hostdomain === 'localhost') {
        hostdomain = 'tagesanzeiger.ch';
      }

      var articleIdFragment = '';

      if (this.props.articleId) {
        articleIdFragment += "/articles/".concat(this.props.articleId);
      }

      json("https://m.".concat(hostdomain, "/api").concat(articleIdFragment, "/external_services"), function (error, data) {
        // region Error Handling
        if (error) {
          console.group('Polymorphic Tracking');
          console.warn('Data could not be loaded from the Newsnet API.');
          console.groupEnd();

          _this3.setState({
            loadingState: ERROR
          });

          return;
        } // endregion


        _this3.setupTracking(data.statistics, data.configs.gtm_id);
      });
    }
    /**
     * Take the downloaded or provided data and set up the various trackers.
     * Currently supports WEMF and Google Tag Manager
     * @private
     * @param {Array<Statistic>} statisticsConfig - The array with the
     * individual statistics configuration objects, as provided by the Newsnet API
     * @param {string} gtmId - The Google Tag Manager ID
     */

  }, {
    key: "setupTracking",
    value: function setupTracking(statisticsConfig, gtmId) {
      var _this4 = this;

      // Do something with the data
      var nestedTrackers = nest().key(function (d) {
        return d.provider;
      }).map(statisticsConfig); // region WEMF (tracking pixels)

      if (this.props.articleId && nestedTrackers.has('wemf')) {
        nestedTrackers.get('wemf').map(function (tracker) {
          // Default tracking URL – mobile version
          var baseTrackerUrl = tracker.url; // Adapt to content width.
          // This is obviously not entirely side-effect free, but we will
          // assume that a user typically doesn't resize their browser
          // window.

          if (browsercheck.isTablet) {
            baseTrackerUrl = tracker.ipad_url;
          }

          if (browsercheck.isDesktop) {
            baseTrackerUrl = tracker.desktop_url;
          }

          var completeUrl = "".concat(baseTrackerUrl, "?r=").concat(encodeURIComponent(document.referrer), "&d=").concat(_this4.loadTimestamp);
          Tracking.trackWithImage(completeUrl);
        });
      } // endregion
      // region GTM
      // This always tracks.


      this.setState({
        loadingState: READY,
        gtmArticleData: nestedTrackers.get('gtm') || [{
          type: 'gtm',
          provider: 'gtm',
          pagetype: 'embedded content',
          category: 'interactive'
        }],
        gtmId: gtmId
      }); // endregion
    }
    /**
     * Helper function. Tracks a visit by calling the URL of a tracking pixel.
     * @private
     * @param {string} src The URL of the tracking pixel to use as the image
     * source.
     */

  }], [{
    key: "trackWithImage",
    value: function trackWithImage(src) {
      // Load the image source URL without actually creating a image DOM element
      // (which, since it's invisible, isn't necessary anyway).
      var image = new Image();
      image.src = src;
    }
  }]);

  return Tracking;
}(React.PureComponent);
export default Tracking;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-tracking/es/index.js
// module id = null
// module chunks = 